import TableRow from './table-row'

const TableBody = ({columns, data, eventTypeId, reality, realty}) => {


    if(!data.length) {
        return (
            <tbody>
                <tr><td colSpan={columns.length} className="no-results">Нет данных, соответствующих выбранным фильтрам</td></tr>  
            </tbody> 
        )        
    }
    return (
        <tbody>
            {data.map((item, i) => <TableRow reality={reality} data={item} columns={columns} key={i} eventTypeId={eventTypeId} realty={realty} />)}    
        </tbody>
    )
}

export default TableBody